import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(auth)/onboarding/protection')({
  component: () => <Navigate to='/onboarding' />,
})
